var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { ProfileService } from "../../../services/profile/profile.service";
export var useProfilesQuery = function (profileIds, params, options) {
    var idsSorted = __spreadArray([], profileIds, true).sort(function (a, b) { return a.localeCompare(b); });
    // followMerge:false returns different profiles for the same ids, so it needs its own cache entry
    var queryKey = (params === null || params === void 0 ? void 0 : params.followMerge) === false ? ['allProfiles', idsSorted, { followMerge: false }] : ['allProfiles', idsSorted];
    return useQuery(queryKey, function () { return __awaiter(void 0, void 0, void 0, function () {
        var content, hasMore, offset, profiles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (idsSorted.length === 0)
                        return [2 /*return*/, Promise.resolve([])];
                    content = [];
                    hasMore = false;
                    offset = 0;
                    _a.label = 1;
                case 1: return [4 /*yield*/, ProfileService.getAllProfiles(__assign({ id: idsSorted, limit: {
                            offset: offset,
                            limit: 1000,
                            sort: [{ field: "name", direction: "ASC" }]
                        } }, params))];
                case 2:
                    profiles = _a.sent();
                    content.push.apply(content, (profiles.content || []));
                    hasMore = !profiles.last;
                    offset += 1000;
                    _a.label = 3;
                case 3:
                    if (hasMore) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4: return [2 /*return*/, content];
            }
        });
    }); }, { keepPreviousData: options === null || options === void 0 ? void 0 : options.keepPreviousData });
};
export var useProfiles = function (profileIds, params, options) {
    var query = useProfilesQuery(profileIds, params, options);
    return query.data || [];
};
export var useProfile = function (profileId) {
    var _a;
    var query = useQuery(['allProfiles', [profileId]], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!profileId)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, ProfileService.getAllProfiles({
                            id: [profileId],
                            limit: {
                                offset: 0,
                                limit: 1,
                                sort: [{ field: "name", direction: "ASC" }]
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return (_a = query.data) === null || _a === void 0 ? void 0 : _a[0];
};
export var useProfileByEmail = function (email) {
    var _a;
    var query = useQuery(['profileByEmail', email], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!email)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, ProfileService.getAllProfiles({
                            email: [email],
                            limit: {
                                offset: 0,
                                limit: 1,
                                sort: [{ field: "name", direction: "ASC" }]
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return (_a = query.data) === null || _a === void 0 ? void 0 : _a[0];
};
export var useProfileFilterOptions = function () {
    return useQuery('profileFilterOptions', ProfileService.getFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
export var useProfileExportFields = function () {
    return useQuery('profileExportFields', ProfileService.getExportFields, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
export var useProfilesByQuery = function (name) {
    var _a;
    var query = useQuery(['profilesByQuery', name], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ProfileService.getAllProfiles({
                        query: name,
                        limit: {
                            offset: 0,
                            limit: 100,
                            sort: [{ field: "name", direction: "ASC" }]
                        }
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return (_a = query.data) === null || _a === void 0 ? void 0 : _a[0];
};
export var useAllProfileNotes = function (profileId) {
    return useQuery(['allProfileNotes', [profileId]], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!profileId)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, ProfileService.getAllProfileNotes(profileId)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response || []];
            }
        });
    }); });
};
